import React, { Fragment } from 'react'
import { Grid, Cell } from 'styled-css-grid'
import styled from 'styled-components'

import styles from './GridMenu.module.css'

import CellItems from '../CellItems/CellItems'

const StyledGrid = styled(Grid)`
    padding: 20px;
    min-height: ${_ => (_.autoHeight ? 'inherit' : '700px')};
    grid-template-rows: 20px;
`

const GridHeader = styled(Cell)`
    color: ${_ => _.theme.grid_header_font_color};
    background-color: ${_ => _.theme.grid_header_background};
    min-height: fit-content;
`

const StyledCell = styled(Cell)`
    ${({ useCommercialName, theme }) =>
        useCommercialName
            ? ''
            : `border-bottom: 1px solid ${theme.grid_border_color};`}

    display: flex;
    align-items: center;
    justify-content: center;
`

const FirstStyledCell = styled(Cell)`
    border-bottom: 1px solid ${_ => _.theme.grid_border_color};

    background-color: ${_ =>
        _.theme.grid_first_column_background
            ? _.theme.grid_first_column_background
            : _.theme.kiosks_background[_.type]};
    h4 {
        color: ${_ => _.theme.grid_header_font_color};
    }
`

const NameHeader = styled.h4`
    grid-column: span ${({ days }) => days};
    color: ${_ => _.theme.grid_header_font_color};
    background-color: ${_ => _.theme.header_background};
    margin-top: 0;
    margin-bottom: 0;
    font-weight: normal;
    display: flex;
    justify-content: center;
    align-items: center;
    height: fit-content;
    padding: 6px;
`

const gridMenu = props => {
    const {
        days = [],
        items = [],
        useCommercialName,
        hideLabels,
        hideIntolerences,
        hideMenuPrice,
        hideRecipePoints,
        hideEnergyKcal,
        showEnergyKcalByPortion,
        dataSource,
        zoom,
        language
    } = props

    return (
        <StyledGrid
            autoHeight={useCommercialName}
            style={{ zoom: zoom }}
            columns={`${
                useCommercialName ? '' : 'minmax(50px, 50px)'
            } ${days.map(_ => '1fr').join(' ')}`}
            gap="0px"
        >
            {!useCommercialName && <Cell />}
            {days.length > 0 &&
                days.map((day, index) => (
                    <GridHeader key={index} className={styles.GridHeader}>
                        {day.date.locale(language).format('dddd')}
                    </GridHeader>
                ))}
            {items.map(({ name, items = [], kioskPicture }, index) => (
                <Fragment key={index}>
                    {useCommercialName && (
                        <NameHeader days={days.length}>{name}</NameHeader>
                    )}
                    {!useCommercialName && (
                        <FirstStyledCell
                            className={styles.FirstColumn}
                            type={kioskPicture || name}
                        >
                            <div
                                style={{
                                    backgroundImage: `url(img/concept/${
                                        props.concept
                                    }/kiosk/${kioskPicture || name}/logo.png?_=9edb01f)`,
                                }}
                                title={name}
                            />
                        </FirstStyledCell>
                    )}
                    {items.map((date, index) => (
                        <StyledCell
                            useCommercialName={useCommercialName}
                            className={styles.Cell}
                            key={index}
                        >
                            <CellItems
                                items={date.items}
                                dataSource={dataSource}
                                hideLabels={hideLabels}
                                hideIntolerences={hideIntolerences}
                                hideMenuPrice={hideMenuPrice}
                                hideRecipePoints={hideRecipePoints}
                                hideEnergyKcal={hideEnergyKcal}
                                showEnergyKcalByPortion={showEnergyKcalByPortion}
                            />
                        </StyledCell>
                    ))}
                </Fragment>
            ))}
        </StyledGrid>
    )
}

export default gridMenu
